import Vue from "vue";
import Vuex from "vuex";
import { queryMyselfInfoApi } from "@/services/systemPage/admin_user.js";
// import { queryMyselfStore } from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航
    navList: [
      /* 超级管理员 */
      {
        id: "1",
        label: "系统管理",
        icon: "el-icon-setting",
        routerName: "SystemPage",
        children: [
          {
            id: "1-1",
            label: "角色账户管理",
            routerName: "Account",
            path: "/management/systemPage/account",
          },
          //菜单menu，账户操作日志
        ],
      },
      {
        id: "2",
        label: "门店配置",
        routerName: "StoreConfig",
        icon: "el-icon-menu",
        children: [
          {
            id: "2-1",
            label: "门店信息维护",
            routerName: "StoreInfo",
            path: "/management/storeConfig/storeInfo",
          },
          {
            id: "2-2",
            label: "门店分配", //用户数量 店长数 交易额
            routerName: "StoreAccountMapping",
            path: "/management/storeConfig/storeAccountMapping",
          },
          // {
          //   id: "2-3",
          //   label: "手机端员工管理",
          //   routerName: "Staff",
          //   path: "/management/myMall/staff",
          // },
        ],
      },
      {
        id: "3",
        label: "我的门店",
        icon: "el-icon-s-shop",
        routerName: "MyStore",
        children: [
          {
            id: "3-1",
            label: "小程序页面配置", //后期增加小程序Ui其他配置，如主题色
            routerName: "StoreBannerConfig",
            path: "/management/myStorePage/bannerConfig",
          },
          {
            id: "3-2",
            label: "门店商品分类",
            routerName: "StoreGoodsKind",
            path: "/management/myStorePage/goodsKind",
          },
          {
            id: "3-3",
            label: "门店商品",
            routerName: "StoreGoodsList",
            path: "/management/myStorePage/goodsList",
          },
          //预约商品管理
          // {
          //   id: "3-4",
          //   label: "预约服务",
          //   routerName: "AppointmentList",
          //   path: "/management/myStorePage/appointmentList",
          // },
        ],
      },
      // {
      //   id: "4",
      //   label: "微商城",
      //   icon: "el-icon-sell",
      //   routerName: "GoodsMall",
      //   children: [
      //     {
      //       id: "4-1",
      //       label: "商品分类",
      //       routerName: "GoodsMallKind",
      //       path: "/management/goodsMall/goodsKind",
      //     },
      //     {
      //       id: "4-2",
      //       label: "商品管理",
      //       routerName: "GoodsMallList",
      //       path: "/management/goodsMall/goodsList",
      //     },
      //   ],
      // },
      // {
      //   id: "5",
      //   label: "会员管理",
      //   icon: "el-icon-trophy",
      //   routerName: "VipCardPage",
      //   path: "/management/vipCardPage",
      //   children: [
      //     {
      //       id: "5-1",
      //       label: "会员列表",
      //       routerName: "VipCardList",
      //       path: "/management/vipCardPage/vipCardList",
      //     },
      //     {
      //       id: "5-2",
      //       label: "会员卡交易记录", //充值记录 消费记录 扫本门店码其他门店会员的消费记录
      //       routerName: "VipCardRecode",
      //       path: "/management/vipCardPage/vipCardRecode",
      //     },
      //   ],
      // },
      {
        id: "6",
        label: "订单中心",//预约单，门店,微商城,积分商城 4大类订单
        icon: "el-icon-printer",
        routerName: "OrderPage",
        children: [
          // {
          //   id: "6-1",
          //   label: "门店预约记单",
          //   icon: "el-icon-s-order",
          //   routerName: "AppointmentOrder",
          //   path: "/management/orderPage/appointmentOrder",
          // },
          {
            id: "6-2",
            label: "门店订单",
            icon: "el-icon-s-order",
            routerName: "StoreOrder",
            path: "/management/orderPage/storeOrder",
          },
          // {
          //   id: "6-3",
          //   label: "微商城订单",
          //   icon: "el-icon-s-order",
          //   routerName: "MallOrder",
          //   path: "/management/orderPage/mallOrder",
          // },
        ],
      },
      // {
      //   id: "7",
      //   label: "商家服务",
      //   icon: "el-icon-s-comment",
      //   routerName: "Examine",
      //   children: [
      //     {
      //       id: "7-1",
      //       label: "续费",
      //       routerName: "Payment",
      //       path: "/management/merchant/payment",
      //     },
      //     {
      //       id: "7-2",
      //       label: "使用指南",
      //       routerName: "",
      //       path: "",
      //     },
      //     {
      //       id: "7-3",
      //       label: "技术支持",
      //       routerName: "",
      //       path: "",
      //     },
      //   ],
      // },
      {
        id: "8",
        label: "个人中心",
        icon: "el-icon-s-custom",
        routerName: "PersonCenter",
        path: "/management/personCenter",
      },
      // {
      //   id: "0",
      //   label: "数据面板",
      //   icon: "el-icon-s-data",
      //   routerName: "DataChart",
      //   path: "/management/dataChart",
      // },
      //     {
      //   id: "8",
      //   label: "积分商城",
      //   icon: "el-icon-star-off",
      //   routerName: "IntegralGoods",
      //   children: [
      //     {
      //       id: "8-1",
      //       label: "商品分类",
      //       routerName: "IntegralGoodsKind",
      //       path: "/management/integralGoods/goodsKind",
      //     },
      //     {
      //       id: "8-2",
      //       label: "商品管理",
      //       routerName: "IntegralGoodsList",
      //       path: "/management/integralGoods/goodsList",
      //     },
      //   ],
      // },
      //营销：优惠券，大转盘
      // {
      //   id: "10",
      //   label: "优惠券管理",
      //   icon: "el-icon-present",
      //   routerName: "Coupon",
      //   path: "/management/myMall/coupon",
      // },
    ],

    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },

  // Actions: 异步操作和业务逻辑处理
  actions: {
    /**
     * 获取用户信息并初始化权限和门店信息
     * @description 登录后或刷新页面时调用，完成用户信息、权限、门店等数据的初始化
     * @returns {Promise} 返回包含 code 和 routerName 的对象
     */
    async getUserInfoAction({ commit, state, dispatch }) {
      // 从本地存储获取 token
      const token = localStorage.getItem("token");

      // 调用接口获取用户信息
      const userInfo = await queryMyselfInfoApi({
        token,
      });

      // 用户无权限或 token 失效时拦截
      if (userInfo?.code !== 200 || !userInfo?.data?.role_menu) {
        return new Promise((reslove, reject) => {
          reslove(userInfo);
        });
      }

      // console.log("userInfo:===================", userInfo);


      commit("updataUserInfo", userInfo?.data);    // 提交用户信息到 state（此时 userInfo 已包含 token）
      commit("updataFilterStoreList", userInfo?.data.storeListData || []);   // 初始化店铺信息

      // 根据用户权限初始化导航数据
      // 深拷贝全量导航列表，避免修改原始数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      // 将用户权限字符串转换为数组（如 "0,1,1-1" => ["0", "1", "1-1"]）
      var roleList = state.userInfo.role_menu?.split(",");

      // 递归筛选出用户有权限的导航项
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });

      // 提交筛选后的导航列表
      commit("updataFilterNavList", copyNavList);

      // 返回成功状态，跳转到欢迎页
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName: "Welcome",
        });
      });
    },

    /**
     * 根据权限递归筛选出导航列表
     * @description 根据用户权限过滤导航菜单，移除无权限的菜单项
     * @param {Array} copyNavList - 导航列表副本
     * @param {Array} roleList - 用户权限ID列表
     */
    async getFilterNavListAction(
      { dispatch, commit },
      { copyNavList, roleList }
    ) {
      // 从后向前遍历，避免删除元素时索引错乱
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        // 如果当前菜单有子菜单且用户有该菜单权限，递归处理子菜单
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        // 如果用户没有该菜单权限，从列表中移除
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },


    /**
     * 查找并激活当前路由对应的导航菜单项
     * @description 递归遍历导航列表,根据路由路径找到对应的菜单项并设置为激活状态
     * @param {Object} context - Vuex action 上下文对象
     * @param {Function} context.dispatch - 分发其他 action
     * @param {Function} context.commit - 提交 mutation
     * @param {Object} payload - 传入参数
     * @param {Array} payload.filterNavList - 过滤后的导航列表
     * @param {String} payload.path - 当前路由路径
     * @returns {Boolean} 是否找到匹配的导航项
     */
    async findActive({ dispatch, commit }, { filterNavList, path }) {
      // 遍历导航列表
      for (let index = 0; index < filterNavList.length; index++) {
        const navItem = filterNavList[index];

        // 找到路径匹配的导航项,更新激活状态
        if (navItem?.path === path) {
          commit("updataActive", navItem.id);
          return true; // 找到后直接返回
        }

        // 如果当前菜单有子菜单且路径不匹配,递归查找子菜单
        if (navItem?.children?.length > 0) {
          const found = await dispatch("findActive", {
            filterNavList: navItem.children,
            path,
          });
          // 子菜单中找到了,提前结束循环
          if (found) return true;
        }
      }
      // 未找到匹配项,清空激活状态
      commit("updataActive", "");
      return false;
    },
  },
});
export default store;
